import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useContext,
  memo,
} from "react";
import { FaSearch, FaLink } from "react-icons/fa";
import "./CodeBook.css";
import bookOpenIcon from "../../assets/bookopen.png";
import booksIcon from "../../assets/books.png";
import bookInactiveIcon from "../../assets/booksinactive.png";
import achiIcon from "../../assets/achiinedx.png";
import indexIcon from "../../assets/Index.png";
import tabularicdIcon from "../../assets/icdtabular.png";
import australianIcon from "../../assets/austrilaincode.png";
import bookIcon from "../../assets/book.png";
import icd10amIcon from "../../assets/icd10am.png";
import starsIcon from "../../assets/starts.png";
import pako from "pako";
import { CodeContext } from "../pages/Coder/Coder";
import { useDebounce } from "use-debounce";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux"; // Import useSelector
import { Spinner } from "react-bootstrap";
import Bookopen from "../../common/assets/images/book-open-02 (1).png";
import LdsRoller from "../../utils/LdsRoller";
import { green } from "@mui/material/colors";
import AustralianCodebook from "./AustralianCodebook";
import earthIcon from "../../assets/earth-asia.png";
import earthinactiveIcon from "../../assets/earth-asia-inactive.png";
import AcsReferencesCodebook from "./ACSReferencesCodebook";
import { setOnChangeCodeBook, updateAcsCode } from "./redux/CodeBookSlicer";
import { useLocation, useNavigate } from "react-router-dom";
// import { clearAcsCode } from "./redux/CodeBookSlicer";
// import {  } from "./redux/CodeBookSlicer";
import { fetchCodebookData, fetchCodebookData13,setActiveIcon, setActiveTab, setRawSearchQuery,setSearchByCodeId } from "./redux/CodeBookSlicer";
import ACSCodeBook13th from "./ACSCodeBook13th";
const CodeBookDev = React.memo(({}) => {
  // console.log( dischargeDate," dischargeDate====================")
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()
  const {
    icd10amTabularData,
    icd10amIndexData,
    achiIndexData,
    achiTabularData,
    icd10amTabularData13,
    icd10amIndexData13,
    achiIndexData13,
    achiTabularData13,
    codeBookLoading,
    codeBookError,
     activeTab,
    activeIcon,
    rawSearchQuery,
    searchByCodeId,
    onChangeCodeBook
  } = useSelector((state) => state.codeBook);
  // console.log( icd10amIndexData13,"jyo1");
  // console.log(icd10amTabularData13,"jyo");
  const [searchQuery, setSearchQuery] = useState("");
  const [droppedCodes, setDroppedCodes] = useState([]);
  const [debouncedQuery] = useDebounce(rawSearchQuery, 300);
  const { selectedCodeBookCode, selectedTabKeyCoding } =
    useContext(CodeContext);
  const [selectedCodebookVersion, setSelectedCodebookVersion] = useState("");
  const [isUserSelectedCodebookVersion, setIsUserSelectedCodebookVersion] =
    useState(false);
  const selectedEpisode = useSelector(
    (state) => state.episodeList.selectedEpisode
  );
  const dischargeDate = selectedEpisode?.separation_date || null;
  const isFetched12 = useSelector((state) => state.codeBook.isFetched12);
  const isFetched13 = useSelector((state) => state.codeBook.isFetched13);
  const { selectedCodeDetails } = useSelector((state) => state.codeSearch);
  // console.log(selectedCodeDetails,"selectedCodeDetails");
  useEffect(() => {
    if (!isUserSelectedCodebookVersion) {
      if (!dischargeDate) {
        // Discharge date missing → default to 13th
        setSelectedCodebookVersion("13th");
      } else {
        const discharge = new Date(dischargeDate);
        const cutoff = new Date("01-07-2025");

        // discharge <= June 30, 2025 → 12th; else → 13th
        if (discharge < cutoff) {
          setSelectedCodebookVersion("12th");
        } else {
          setSelectedCodebookVersion("13th");
        }
      }
    }
  }, [dischargeDate, isUserSelectedCodebookVersion]);

  const handleChange = (e) => {
    setSelectedCodebookVersion(e.target.value);
    setIsUserSelectedCodebookVersion(true);
  };

  // This depends on your selected edition
  // useEffect(() => {
  //   if (selectedCodebookVersion === "12th" && !isFetched12) {
  //     dispatch(fetchCodebookData());
  //   } else if (selectedCodebookVersion === "13th" && !isFetched13) {
  //     dispatch(fetchCodebookData13());
  //   }
  // }, [selectedCodebookVersion, isFetched12, isFetched13, dispatch]);
  // useEffect(() => {
  //   const shouldFetch12 =
  //     selectedCodebookVersion === "12th" &&
  //     !isFetched12;

  //   const shouldFetch13 =
  //     selectedCodebookVersion === "13th" &&
  //     !isFetched13;

  //   if (shouldFetch12) {
  //     dispatch(fetchCodebookData());
  //   } else if (shouldFetch13) {
  //     dispatch(fetchCodebookData13());
  //   }
  // }, [selectedCodebookVersion, isFetched12, isFetched13, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedCodebookVersion === "12th" && !isFetched12) {
        dispatch(fetchCodebookData());
      } else if (selectedCodebookVersion === "13th" && !isFetched13) {
        dispatch(fetchCodebookData13());
      }
    };

    fetchData();
  }, [selectedCodebookVersion, isFetched12, isFetched13, dispatch]);

  const tabsConfig = useMemo(() => {
    const is13 = selectedCodebookVersion === "13th";
    return [
      {
        name: "ICD 10 AM Index",
        data: is13 ? icd10amIndexData13 : icd10amIndexData,
      },
      {
        name: "ICD 10 AM Tabular",
        data: is13 ? icd10amTabularData13 : icd10amTabularData,
      },
      {
        name: "ACHI Tabular",
        data: is13 ? achiTabularData13 : achiTabularData,
      },
      { name: "ACHI Index", data: is13 ? achiIndexData13 : achiIndexData },
      { name: "Australian Coding Standard", data: [] },
      { name: "ACS References", data: [] },
    ];
  }, [
    selectedCodebookVersion,
    icd10amIndexData,
    icd10amTabularData,
    achiTabularData,
    achiIndexData,
    icd10amIndexData13,
    icd10amTabularData13,
    achiTabularData13,
    achiIndexData13,
  ]);

  const getTabError = () => {
    if (!codeBookError) return null;
    switch (activeTab) {
      case "ICD 10 AM Tabular":
        return codeBookError.icd10amTabular
          ? `Failed to load ICD 10 AM Tabular data: ${codeBookError.icd10amTabular}`
          : null;
      case "ICD 10 AM Index":
        return codeBookError.icd10amIndex
          ? `Failed to load ICD 10 AM Index data: ${codeBookError.icd10amIndex}`
          : null;
      case "ACHI Tabular":
        return codeBookError.achiTabular
          ? `Failed to load ACHI Tabular data: ${codeBookError.achiTabular}`
          : null;
      case "ACHI Index":
        return codeBookError.achiIndex
          ? `Failed to load ACHI Index data: ${codeBookError.achiIndex}`
          : null;
      default:
        return null;
    }
  };

  const tabError = getTabError();

  useEffect(() => {
    const savedActiveTab = localStorage.getItem("activeTab");
    const savedActiveIcon = localStorage.getItem("activeIcon");

    if (savedActiveTab) {
      dispatch(setActiveTab(savedActiveTab)); // Set active tab if saved in localStorage
    }

    if (savedActiveIcon) {
      dispatch(setActiveIcon(savedActiveIcon)) // Set active icon if saved in localStorage
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab); // Save active tab to localStorage
    localStorage.setItem("activeIcon", activeIcon); // Save active icon to localStorage
  }, [activeTab, activeIcon]);

  useEffect(() => {
    // --- Priority 1: CodeAssist search state ---
    if (selectedCodeDetails) {
      setSelectedCodebookVersion("13th"); // force 13th

      const { category, code_id, value, isFromTabular } = selectedCodeDetails;
       dispatch(setSearchByCodeId(code_id))
       dispatch(setRawSearchQuery(value))
      if (category === "Additional Diagnoses") {
        if (!isFromTabular) {
          // Case 1: Additional Diagnoses from Index
          dispatch(setActiveIcon("ICD"));
          dispatch(setActiveTab("ICD 10 AM Index"))
          dispatch(setRawSearchQuery(value))
          return; 
        } else {
          // Case 2: Additional Diagnoses from Tabular
          dispatch(setActiveIcon("Tabular"))
          dispatch(setActiveTab("ICD 10 AM Tabular"))
          dispatch(setRawSearchQuery(value))
          return;
        }
      } 
        if (category === "Principal Diagnosis") {
        if (!isFromTabular) {
          // Case 1: Additional Diagnoses from Index
          dispatch(setActiveIcon("ICD"));
          dispatch(setActiveTab("ICD 10 AM Index"))
          dispatch(setRawSearchQuery(value))
          return; 
        } else {
          // Case 2: Additional Diagnoses from Tabular
          dispatch(setActiveIcon("Tabular"))
          dispatch(setActiveTab("ICD 10 AM Tabular"))
          dispatch(setRawSearchQuery(value))
          return;
        }
      } 
      if(category==="Procedure Codes"){
        if (!isFromTabular) {
          // Case 1: Additional Diagnoses from Index
          dispatch(setActiveIcon("ICD"));
          dispatch(setActiveTab("ACHI Index"))
          dispatch(setRawSearchQuery(value))
          return; 
        } else {
          // Case 2: Additional Diagnoses from Tabular
          dispatch(setActiveIcon("Tabular"))
          dispatch(setActiveTab("ACHI Tabular"))
          dispatch(setRawSearchQuery(value))
          return;
        }
      }
    }  
    // --- Priority 2: Normal flow ---
   if (selectedCodeBookCode && selectedTabKeyCoding) {
      // console.log(selectedCodeBookCode,"selectedCodeBookCode")
      dispatch(setSearchByCodeId(null))
      // Check both are available
      dispatch(setRawSearchQuery(selectedCodeBookCode))
      if (selectedTabKeyCoding === "ACHI") {
        dispatch(setActiveIcon("Tabular")) // Or your preferred ACHI icon
        dispatch(setActiveTab("ACHI Tabular")) // Correct tab for ACHI
      } else {
        // Either ICD or default (ICD)
        dispatch(setActiveIcon("Tabular"))
        dispatch(setActiveTab("ICD 10 AM Tabular")) // Correct tab for ICD (and default)
      }
    } else {
      dispatch(setSearchByCodeId(null))
      dispatch(setRawSearchQuery(""))
      dispatch(setActiveIcon("ICD"))
      dispatch(setActiveTab("ICD 10 AM Index"))
    }
  }, [selectedCodeDetails, selectedCodeBookCode, selectedTabKeyCoding]);

  useEffect(() => {
    if (debouncedQuery?.length >= 2) {
      setSearchQuery(debouncedQuery);
    } else {
      setSearchQuery(""); 
    }
  }, [debouncedQuery]); 

  // const filterData = (items, query) => {
  //   // if (!query) return items; // Return original items if query is empty
  //   if (!query || query.length < 3) return items; // Return empty array

  //   const lowerCaseQuery = typeof query === "string" ? query.toLowerCase() : ""; // Handle anything

  //   const results = [];
  //   const filterRecursive = (items) => {
  //     // Inner recursive function
  //     return items
  //       .map((item) => {
  //         const filteredChildren = item.children
  //           ? filterRecursive(item.children)
  //           : [];
  //         const matchesParent =
  //           (item.name && item.name.toLowerCase().includes(lowerCaseQuery)) ||
  //           (item.description &&
  //             item.description.toLowerCase().includes(lowerCaseQuery));

  //         // const matches = matchesParent || filteredChildren.length > 0;

  //         const childrenToInclude = matchesParent
  //           ? item.children || []
  //           : filteredChildren;

  //         return {
  //           ...item,
  //           // children: filteredChildren,
  //           // matches,
  //           children: childrenToInclude, // Preserve all children if parent matches
  //           matches: matchesParent || childrenToInclude.length > 0,
  //         };
  //       })
  //       .filter((item) => item.matches || item.children?.length > 0);
  //   };

  //   return filterRecursive(items);
  // };

  const filterData = (items, query, codeId = null) => {
  // If we have a specific code ID to search for
  if (codeId) {
    const findByIdRecursive = (items, targetId) => {
      for (const item of items) {
        // Check if this item matches the target ID
        if (item.id === targetId) {
          return [item]; // Return only the matching item
        }
        
        // Check children recursively
        if (item.children) {
          const foundInChildren = findByIdRecursive(item.children, targetId);
          if (foundInChildren.length > 0) {
            // Return the parent with only the matching child
            return [{
              ...item,
              children: foundInChildren,
              matches: true
            }];
          }
        }
      }
      return [];
    };
    
    return findByIdRecursive(items, codeId);
  }

   // Original text-based search (fallback)
  if (!query || query.length < 2) return items;

  const lowerCaseQuery = typeof query === "string" ? query.toLowerCase() : "";  
  const results = [];
  const filterRecursive = (items) => {
    return items
      .map((item) => {
        const filteredChildren = item.children
          ? filterRecursive(item.children)
          : [];
        const matchesParent =
          (item.name && item.name.toLowerCase().includes(lowerCaseQuery)) ||
          (item.description && item.description.toLowerCase().includes(lowerCaseQuery));

        const childrenToInclude = matchesParent
          ? item.children || []
          : filteredChildren;

        return {
          ...item,
          children: childrenToInclude,
          matches: matchesParent || childrenToInclude.length > 0,
        };
      })
      .filter((item) => item.matches || item.children?.length > 0);
  };

  return filterRecursive(items);
};

  // const filteredDataMemo = useMemo(() => {
  //   const currentTabData = tabsConfig.find(
  //     (tab) => tab.name === activeTab
  //   )?.data;
  //   return filterData(currentTabData || [], searchQuery);
  // }, [activeTab, searchQuery, tabsConfig]); 
  const filteredDataMemo = useMemo(() => {
  const currentTabData = tabsConfig.find(
    (tab) => tab.name === activeTab
  )?.data;
  
  return filterData(currentTabData || [], searchQuery, searchByCodeId);
}, [activeTab, searchQuery, searchByCodeId, tabsConfig]); 

  const handleSearchChange = (e) => {
    console.log('seeins',e.target.value);
    if(e.target.value){
    dispatch(setOnChangeCodeBook(true));
    }else{
      dispatch(setOnChangeCodeBook(false));
    }
    
    const newValue = e.target.value;
    if (newValue !== rawSearchQuery) {
      dispatch(setRawSearchQuery(newValue))
      // dispatch(setSearchByCodeId(null))
      if (searchByCodeId) dispatch(setSearchByCodeId(null));
    }
      // console.log('onChangeCodeBook');
  };

  const handleIconClick = (icon) => {
    dispatch(setActiveIcon(icon))
    dispatch(setSearchByCodeId(null))
     dispatch(setRawSearchQuery(""))
    if (icon === "ICD") dispatch(setActiveTab("ICD 10 AM Index"))
    else if (icon === "Tabular") dispatch(setActiveTab("ICD 10 AM Tabular"))
    else if (icon === "Coding") {
      dispatch(updateAcsCode(""));
      dispatch(setActiveTab("Australian Coding Standard"))
    }
    else if (icon === "References") dispatch(setActiveTab("ACS References"))

    // if (icon !== "Coding") {
    //   navigate('/coder')
    // };
  };

  const getIcon = (icon) => {
    if (icon === "ICD") {
      return activeTab === "ICD 10 AM Index"
        ? booksIcon
        : activeTab === "ACHI Index"
        ? achiIcon
        : bookInactiveIcon; // Inactive icon for ICD
    }

    if (icon === "Tabular") {
      return activeTab === "ICD 10 AM Tabular"
        ? tabularicdIcon
        : activeTab === "ACHI Tabular"
        ? icd10amIcon
        : bookInactiveIcon; // Inactive icon for Tabular
    }

    if (icon === "Coding") {
      return activeTab === "Australian Coding Standard"
        ? australianIcon
        : bookIcon;
    }
    if (icon === "References") {
      return activeTab === "ACS References" ? earthIcon : earthIcon;
    }

    return bookInactiveIcon;
  };

  const handleDrop = (code) => {
    setDroppedCodes((prev) => [...prev, code]);
  };

  const [displayedItems, setDisplayedItems] = useState([]); // Items to render
  const [loadMore, setLoadMore] = useState(50); // Number of items to load
  const searchResultsRef = React.useRef(null);
  useEffect(() => {
    setLoadMore(50);
  }, [activeTab, searchQuery, selectedCodebookVersion]);
  useEffect(() => {
    setDisplayedItems(filteredDataMemo?.slice(0, loadMore));
  }, [filteredDataMemo, loadMore]);

  const handleScroll = useCallback(() => {
    if (!searchResultsRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = searchResultsRef.current;

    // If scrolled to the bottom, load 10 more items
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      setLoadMore((prev) => prev + 10);
    }
  }, []);

  useEffect(() => {
    const element = searchResultsRef.current;
    if (element) {
      element.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (element) {
        element.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);
  // useEffect(()=>{
  //   console.log(onChangeCodeBook,'onChangeCodeBook');

  // },[onChangeCodeBook])
  
  return (
    <div className="codebook-container">
      <div className="codebook1-header">
        <span
          className={`header-navicon ${
            activeIcon === "ICD" ? "active-icon" : ""
          }`}
          onClick={() => handleIconClick("ICD")}
        >
          <img src={getIcon("ICD")} alt="ICD Icon" width={30} height={30} />
        </span>
        <span
          className={`header-navicon ${
            activeIcon === "Tabular" ? "active-icon" : ""
          }`}
          onClick={() => handleIconClick("Tabular")}
        >
          <img
            src={getIcon("Tabular")}
            alt="Tabular Icon"
            width={30}
            height={30}
          />
        </span>
        <span
          className={`header-navicon ${
            activeIcon === "Coding" ? "active-icon" : ""
          }`}
          onClick={() => handleIconClick("Coding")}
        >
          <img
            src={getIcon("Coding")}
            alt="Coding Icon"
            width={30}
            height={30}
          />
        </span>
        {/* <span
          className={`header-navicon ${activeIcon === "References" ? "active-icon" : ""}`}
          onClick={() => handleIconClick("References")}
        >
          <img src={getIcon("References")} alt="Coding Icon" width={30} height={30} />
        </span> */}
        <span style={{ marginLeft: "auto" }}>
          <select
            className="codebook-version-select"
            value={selectedCodebookVersion}
            onChange={handleChange}
          >
            <option value="12th">12th</option>
            <option value="13th">13th</option>
          </select>
        </span>
      </div>

      <div className="tabs-codes">
        {activeIcon === "ICD" && (
          <>
            <button
              className={activeTab === "ICD 10 AM Index" ? "active" : ""}
              style={{
                borderBottomColor:
                  activeTab === "ICD 10 AM Index" ? "#FFE404" : "transparent",
              }}
              onClick={() => dispatch(setActiveTab("ICD 10 AM Index"))}
            >
              ICD 10 AM Index
            </button>
            <button
              className={activeTab === "ACHI Index" ? "active" : ""}
              style={{
                borderBottomColor:
                  activeTab === "ACHI Index" ? "green" : "transparent",
              }}
              onClick={() => dispatch(setActiveTab("ACHI Index"))}
            >
              ACHI Index
            </button>
          </>
        )}
        {activeIcon === "Tabular" && (
          <>
            <button
              className={activeTab === "ICD 10 AM Tabular" ? "active" : ""}
              style={{
                borderBottomColor:
                  activeTab === "ICD 10 AM Tabular" ? "red" : "transparent",
              }}
              onClick={() => dispatch(setActiveTab("ICD 10 AM Tabular"))}
            >
              ICD 10 AM Tabular
            </button>
            <button
              className={activeTab === "ACHI Tabular" ? "active" : ""}
              style={{
                borderBottomColor:
                  activeTab === "ACHI Tabular" ? "blue" : "transparent",
              }}
              onClick={() => dispatch(setActiveTab("ACHI Tabular"))}
            >
              ACHI Tabular
            </button>
          </>
        )}
        {activeIcon === "Coding" && (
          <button
            className={
              activeTab === "Australian Coding Standard" ? "active" : ""
            }
            style={{ borderBottomColor: "purple" }}
          >
            Australian Coding Standards (ACS)
          </button>
        )}
        {/* {activeIcon === "References" && (
          <button className={activeTab === "ACS References" ? "active" : ""} style={{ borderBottomColor: "blue" }}>
            ACS References
          </button>
        )} */}
      </div>

      {/* <div className="search-bar-code">
        <FaSearch className="search-icon" />
        <input
          type="text"
          className="search-input"
          placeholder="Search by code or description"
          value={rawSearchQuery}
          onChange={handleSearchChange}
        />
 
      </div> */}
      {activeTab !== "Australian Coding Standard" && (
        <div className="search-bar-code">
          <FaSearch className="codebook-search-icon" />
          <input
            type="text"
            className="search-input"
            placeholder="Search by code or description"
            value={rawSearchQuery}
            onChange={handleSearchChange}
          />
        </div>
      )}
      {activeTab === "Australian Coding Standard" ? (
        selectedCodebookVersion === "12th" ? (
          <AustralianCodebook />
        ) : (
          <ACSCodeBook13th />
        )
      ) : (
        <div className="search-results" ref={searchResultsRef}>
          {/* {activeTab === "Australian Coding Standard" && <AustralianCodebook />} */}
          <div className="accordion-container">
            {/* {
            codeBookLoading ? <div className="codebook-loader">
              <Spinner />{" "}
            </div> : <>
              {displayedItems.map((item,index) => (<AccordionItem key={index} item={item} searchQuery={searchQuery} activeTab={activeTab} />))}
            </>
          } */}
            {codeBookLoading ||
            (selectedCodebookVersion === "12th" && !isFetched12) ||
            (selectedCodebookVersion === "13th" && !isFetched13) ? (
              <div className="codebook-loader">
                <LdsRoller />
              </div>
            ) : (
              <>
                {displayedItems.length > 0
                  ? displayedItems.map((item, index) => (
                      <AccordionItem
                        key={index}
                        item={item}
                        searchByCodeId={searchByCodeId}
                        searchQuery={searchQuery}
                        activeTab={activeTab}
                        isTopLevel={item.children.length === 0}
                        setActiveTab={setActiveTab}
                        dispatch={dispatch}
                        setActiveIcon={setActiveIcon}
                      />
                    ))
                  : searchQuery.length >= 2 && <div>No matches found</div>}
              </>
            )}
          </div>

          {/* <div className="staricon">
            <img src={starsIcon} alt="Star Icon" />
        </div> */}
        </div>
      )}
    </div>
  );
});

const getItemCodes = (item, activeTab) => {
  const codeString = getItemCode(item, activeTab); // Get the combined code string
  if (!codeString) return []; // Handle cases where codeString is empty or null
  if (activeTab === "ACHI Tabular" || activeTab === "ACHI Index") {
    // ACHI: Return the entire string as one code, regardless of brackets.
    return [codeString];
  } else {
    // ICD: Split by common delimiters, but ONLY if they are OUTSIDE brackets.
    const delimiter = /[†* ,]+(?![^[]*\])/; // Split outside of brackets
    const codes = codeString
      .split(delimiter)
      .filter((code) => code.trim() !== "");
    return codes;
  }
};

const getItemCode = (item, activeTab) => {
  switch (activeTab) {
    case "ICD 10 AM Index":
    case "ACHI Index":
      return item.description;
    case "ICD 10 AM Tabular":
    case "ACHI Tabular":
    case "Australian Coding Standard":
      return item.name;
    default:
      return item.name;
  }
};
// const highlightText = (text, query) => {

//   if (!query || query.length < 3 || !text) {
//     return text; // Return original text if query is empty or too short
//   }

//   const lowerCaseText = text.toLowerCase();
//   const lowerCaseQuery = query.toLowerCase();

//   const parts = [];
//   let lastIndex = 0;

//   while (true) {
//     const index = lowerCaseText.indexOf(lowerCaseQuery, lastIndex);
//     if (index === -1) {
//       parts.push(text.substring(lastIndex));
//       break;
//     }

//     parts.push(text.substring(lastIndex, index));
//     parts.push(
//       <span className="highlighted">
//         {text.substring(index, index + query.length)}
//       </span>
//     );
//     lastIndex = index + query.length;
//   }

//   return parts;
// };
const highlightText = (text, query, onChangeCodeBook = false) => {
  // console.log(onChangeCodeBook,'cskdhsjdhgfsedf');
  
  if (!query || query.length < 2 || !text) {
    return text;
  }

  // Escape special regex characters
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // If onChangeCodeBook is true, do substring match; else exact match
const regex = onChangeCodeBook
  ? new RegExp(escapedQuery, 'i')         // substring match
  : new RegExp(`^${escapedQuery}$`);  

  if (regex.test(text)) {
    return <span className="highlighted">{text}</span>;
  }
  return text;
};
const handleDragStartLogic = (e, draggableCodes, activeTab) => {
  if (draggableCodes.length > 0) {
    const dragData = {
      codes: draggableCodes,
      tab: activeTab,
    };
    e.dataTransfer.setData("application/json", JSON.stringify(dragData));
    e.dataTransfer.setData("text/plain", JSON.stringify(draggableCodes));
    e.dataTransfer.setData(
      "text/uri-list",
      `data:text/plain;charset=utf-8,${encodeURIComponent(
        JSON.stringify(draggableCodes)
      )}`
    );
    // console.log("Dragging medical codes:", dragData.codes, "from tab:", dragData.tab);
  } else {
    e.preventDefault();
  }
};

const AccordionItem = ({
  item,
  activeTab,
  searchQuery,
  searchByCodeId,
  isTopLevel,
  dispatch,
  setActiveTab,
  setActiveIcon,
}) => {
  const { copiedCodes, setCopiedCodes } = useContext(CodeContext);
  const [isCopied, setIsCopied] = useState(false);
  const [localIsOpen, setLocalIsOpen] = useState(false);
   const {
    onChangeCodeBook
  } = useSelector((state) => state.codeBook);

  const isHighlightedById = searchByCodeId && item.id === searchByCodeId;
   useEffect(() => {
    if (searchByCodeId) {
      if (item.id === searchByCodeId || 
          (item.children && item.children.some(child => child.id === searchByCodeId))) {
        setLocalIsOpen(true);
      }
    } else if (searchQuery.length > 1 && item.children?.some((child) => child.matches)) {
      setLocalIsOpen(true);
    } else if (searchQuery.length < 2) {
      setLocalIsOpen(false); // Close if no search or short query
    }
  }, [searchQuery, item.children]);
  useEffect(() => {
    if (searchQuery.length > 1) {
      // Check if the item or any of its descendants have matches
      const hasMatches = item.matches || (item.children?.some(child => child.matches || child.children?.some(c => c.matches)));
      setLocalIsOpen(hasMatches);
    } else {
      setLocalIsOpen(false);
    }
  }, [searchQuery, searchByCodeId, item.children, item.id])
  // useEffect(() => {
  //   if (
  //     searchQuery.length > 2 &&
  //     item.children?.some((child) => child.matches)
  //   ) {
  //     setLocalIsOpen(true); // Auto-open only if a child matches
  //   } else if (searchQuery.length < 3) {
  //     setLocalIsOpen(false); // Close if no search or short query
  //   }
  // }, [searchQuery, item.children]);
  useEffect(() => {
    if (searchQuery.length > 1) {
      // Check if the item or any of its descendants have matches
      const hasMatches = item.matches || (item.children?.some(child => child.matches || child.children?.some(c => c.matches)));
      setLocalIsOpen(hasMatches);
    } else {
      setLocalIsOpen(false);
    }
  }, [searchQuery, item]);
  const toggleOpen = () => {
    setLocalIsOpen(!localIsOpen);
  };

  const handleAcsFunction = (acsCode) => {
    console.log("navigate click");
    dispatch(updateAcsCode(acsCode));
    dispatch(setActiveTab("Australian Coding Standard"))
    dispatch(setActiveIcon("Coding"))
  };

  const codes = getItemCodes(item, activeTab);
  const draggableCodes = codes.filter((code) => {
    if (activeTab === "ACHI Tabular" || activeTab === "ACHI Index") {
      // return true;
      return code.includes("-");
    } else {
      return !code.includes("-");
    }
  });

  const handleDragStart = useCallback(
    (e, draggableCodes) => {
      handleDragStartLogic(e, draggableCodes, activeTab);
    },
    [activeTab]
  );

  const handleCopyCode = (e) => {
    if (
      (activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular") &&
      (!item.children || item.children.length === 0)
    ) {
      // Tabular view logic
      if (draggableCodes.length > 0) {
        const codesString = draggableCodes.join(",");
        // console.log(codesString, "copy code========");
        navigator.clipboard
          .writeText(codesString)
          .then(() => {
            setIsCopied(true);
            setCopiedCodes(codesString.split(","));
            setTimeout(() => setIsCopied(false), 3000);
          })
          .catch((err) => {
            console.error("Clipboard copy error:", err); // Log the error for debugging
            if (err instanceof Error) {
              toast.error("Failed to copy: " + err.message);
            } else {
              toast.error("Failed to copy: An unknown error occurred.");
            }
          });
      }
    } else if (
      (activeTab === "ICD 10 AM Index" || activeTab === "ACHI Index") &&
      draggableCodes.length > 0
    ) {
      // Index view logic
      const codesString = draggableCodes.join(",");
      // console.log(codesString, "copy code========");
      navigator.clipboard
        .writeText(codesString)
        .then(() => {
          setIsCopied(true);
          setCopiedCodes(codesString.split(","));
          setTimeout(() => setIsCopied(false), 3000);
        })
        .catch((err) => {
          // console.error("Clipboard copy error:", err); // Log the error for debugging
          if (err instanceof Error) {
            toast.error("Failed to copy: " + err.message);
          } else {
            toast.error("Failed to copy: An unknown error occurred.");
          }
        });
    }
  };
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);
  return (
    <div  key={"shbfsh"} className={`codebook-wrapper accordion-item ${isHighlightedById ? 'highlighted-item' : ''}`}>
      {isCopied && ( // Conditionally render the button
        <button className="code-copied-button">
          Code Copied{" "}
          <img src={Bookopen} alt="plus" className="codebook-copy-icon" />
        </button>
      )}
      <div className="accordion-header" onClick={toggleOpen}>
        <div className={`header-content ${isHighlightedById ? 'highlighted-by-id' : ''}`}>
          {item.children?.length > 0 && (
            <span className="accordion-icon">{localIsOpen ? "▼" : "▶"}</span>
          )}
          <span
            onClick={handleCopyCode}
            draggable={
              activeTab === "ICD 10 AM Tabular" ||
              (activeTab === "ACHI Tabular" &&
                (!item.children || item.children.length === 0))
            }
            onDragStart={
              (activeTab === "ICD 10 AM Tabular" ||
                activeTab === "ACHI Tabular") &&
              (!item.children || item.children.length === 0)
                ? (e) => handleDragStart(e, draggableCodes)
                : null
            }
            style={{
              color:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 AM Tabular" ||
                  activeTab === "ACHI Tabular") &&
                (!item.children || item.children.length === 0)
                  ? "blue"
                  : "inherit",
              textDecoration:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 AM Tabular" ||
                  activeTab === "ACHI Tabular") &&
                (!item.children || item.children.length === 0)
                  ? "underline"
                  : "none",
              fontWeight:
                isTopLevel || item.children?.length > 0 ? "bold" : "normal",
            }}
          >
            {highlightText(item.name, searchQuery,onChangeCodeBook)}
          </span>
          <span
            className="item-description"
            onClick={handleCopyCode}
            draggable={
              activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular"
                ? false
                : draggableCodes.length > 0
            }
            onDragStart={
              activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular"
                ? null
                : draggableCodes.length > 0
                ? (e) => handleDragStart(e, draggableCodes)
                : null
            }
            style={{
              color:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 AM Index" || activeTab === "ACHI Index")
                  ? "blue"
                  : "inherit",
              textDecoration:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 AM Index" || activeTab === "ACHI Index")
                  ? "underline"
                  : "none",
            }}
          >
            <span className="item-descrpition-value">
              {highlightText(item.description, searchQuery,onChangeCodeBook)}
            </span>

            {/* {item?.acs ? (
              <span className="item-acs-value">
                {" "}
                <button
                  className="acs-btn"
                  onClick={() => {
                    //  console.log("ACS value:", item?.acs);
                    handleAcsFunction(item?.acs);
                  }}
                >
                  ACS
                </button>{" "}
              </span>
            ) : (
              ""
            )}
          </span> */}

          {(item?.acs && activeTab!=="ICD 10 AM Index") ?  <span className="item-acs-value"> <button className="acs-btn" onClick={() => {
              //  console.log("ACS value:", item?.acs);
              handleAcsFunction(item?.acs);
            }}
            >ACS</button> </span> : ""}
          </span>

          {item.see && (
            <span className="font_purple">
              {" "}
              – {highlightText(item.see.replace(/^�\s*/, ""),searchQuery)}
            </span>
          )}
          {item.seealso && (
            <span className="font_orange">
              {" "}
              – {highlightText(item.seealso.replace(/^�\s*/, ""),searchQuery)}
            </span>
          )}
          {item.inclusion && localIsOpen && (
            <div className="font_green">
              <b>Includes</b> : {highlightText(item.inclusion, searchQuery)}
            </div>
          )}
          {item.useAdditional && localIsOpen && (
            <div className="font_blud">
              <b>useAdditional</b> :{" "}
              {highlightText(item.useAdditional, searchQuery)}
            </div>
          )}
          {item.exclusion && localIsOpen && (
            <div className="font_red">
              <b>Excludes</b> : {highlightText(item.exclusion, searchQuery)}
            </div>
          )}
            {/* {item.codeto && localIsOpen && (
            <div className="font_purple11">
              <b>Code To</b> : {highlightText(item.codeto, searchQuery)}
            </div>
          )} */}
           {item.definition && localIsOpen && (
            <div className="font_pink">
              <b>Definition</b> : {highlightText(item.definition, searchQuery)}
            </div>
          )}
            {item.note && localIsOpen && (
            <div className="font_yellow">
              <b>Note</b> : {highlightText(item.note, searchQuery)}
            </div>
          )}
            {item.stylednote && localIsOpen && (
            <div className="font_blue">
              <b>Stylednote</b> : {highlightText(item.stylednote, searchQuery)}
            </div>
          )}
        </div>
      </div>
      {localIsOpen && item.children?.length > 0 && (
        <div className="accordion-children">
          {item.children.map((child) => (
            <AccordionItem
              key={child.id}
              item={child}
              activeTab={activeTab}
              searchByCodeId={searchByCodeId}
              searchQuery={searchQuery}
              setActiveTab={setActiveTab}
              dispatch={dispatch}
              setActiveIcon={setActiveIcon}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default React.memo(CodeBookDev);